import { FormattedMessage } from 'react-intl';

import { Typography } from '@/components/ui/typography';
import { useCurrencySymbol } from '@/hooks/use-currency-symbol';
import { getChannelName } from '@/utils/channel-names';
import { formatShortDate } from '@/utils/date-util';

interface ChannelSummaryItemProps {
  channelSlug: string;
  startsAt: string | null;
  endAt: string | null;
  totalChannelBudget: number | null;
}

export function ChannelSummaryItem({
  channelSlug,
  startsAt,
  endAt,
  totalChannelBudget,
}: ChannelSummaryItemProps) {
  const { formatCurrency } = useCurrencySymbol();

  return (
    <div className="flex w-full items-center justify-between gap-4">
      <div className="flex flex-col items-start justify-center gap-1">
        <Typography variant="body2">
          <FormattedMessage
            defaultMessage="{channelName} Sponsored Job"
            values={{ channelName: getChannelName(channelSlug) }}
            description="Channel name for a sponsored job"
          />
        </Typography>
        <Typography variant="small1" className="!text-fx-neutral-600">
          {`${startsAt ? formatShortDate(startsAt) : 'Today'}  -  ${
            endAt ? formatShortDate(endAt) : 'Ongoing'
          }`}
        </Typography>
      </div>

      <Typography variant="h4" className="!text-fx-neutral-600">
        {totalChannelBudget
          ? formatCurrency(totalChannelBudget)
          : formatCurrency(0)}
      </Typography>
    </div>
  );
}
